import { v4 as uuid } from "uuid";
import {Model} from "../base/Model";
import {Collection} from "../base/Collection";
    
export class ContactModel extends Model   {
phone: string = "";
mobile: string = "";
fax: string = "";
other1: string = "";
other2: string = "";
other3: string = "";
other4: string = "";
contact_type_key: string = "";
company_key: string;
user_key: string;

    constructor(data = null) {
        super();
        if(data) {
            this.createModel(data);
        }
    }      


  
}